import { Box, Typography } from "@mui/material";
import { get } from "lodash";
import { useOutletContext, useLocation } from "react-router-dom";
import Styles from "../theme/commonCss/Styles";
import RemoteAppLoader from "./RemoteAppLoader";
import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { useCaseBuilderActions } from "../store/reducers/usecase-management";
import OntologySelector from "./OntologySelector";

const DashboardLoader = ({ deployedUsecaseData, ontologyData }: any) => {
    const outletContext: any = useOutletContext();
    const { grafana_uid, use_case_type, use_case_id }: any = get(outletContext, 'customAppConfig', {});
    const location = useLocation();
    const dispatch = useDispatch();
    const grafanaBaseUrl = process.env.REACT_APP_GRAFANA_URL || 'http://test-iotb-ubuntu-prj-cf.ad.harman.com';
    const isRootDashboard = location.pathname === '/dashboard' || location.pathname === '/dashboard/';

    const [selectedOntology, setSelectedOntology] = useState(0);

    const useCase = useMemo(() => deployedUsecaseData.find((uc: any) => uc.use_case_id === use_case_id), [deployedUsecaseData, use_case_id]);

    useEffect(() => {
      if (useCase) {
        setSelectedOntology(useCase.last_selected_onto_manage_id || 0);
      }
    }, [useCase]);

    if (use_case_type === 'customApplication') {
        return (<RemoteAppLoader />)
    } else {
        // if (isRootDashboard) {
        //     return (
        //         <Box
        //             sx={{
        //                 ...Styles.masterPaperContainer,
        //                 border: `1px solid #D9DFED`,
        //                 backgroundColor: '#fff',
        //                 overflow: 'hidden',
        //                 height: 'calc(100vh - 185px)',
        //             }}
        //         >
        //             <iframe
        //                 title='Grafana'
        //                 src={`http://demdlx261as401.ad.harman.com/grafana?refresh=5s&theme=light`}
        //                 // src={`http://ec2-13-127-207-214.ap-south-1.compute.amazonaws.com:30300/public-dashboards/33ba451067fe4d8b82da3fcf12ec3605?orgId=1&from=now-5m&to=now&timezone=browser`}
        //                 style={{ width: '100%', height: '100%', border: 'none' }}
        //             />
        //         </Box>
        //     );
        // }

        if (grafana_uid) {
            const url = `${grafanaBaseUrl}/grafana/d/${grafana_uid}?&var-onto_manage_id=${selectedOntology}&kiosk&theme=light`;
            // const url = `http://host.docker.internal:3001/d/adwrlpk/water?kiosk&orgId=1&var-onto_manage_id=${selectedOntology}`;
            return (
              <Box>
                <Box sx={{ mb: 4 }}>
                  <OntologySelector
                    padding='0'
                    ontologyData={ontologyData}
                    showLayout={true}
                    hideBottomRow={true}
                    onOntoFilterChange={({ onto_manage_id }: { onto_manage_id: number }) => {
                      setSelectedOntology(onto_manage_id);
                      dispatch(useCaseBuilderActions.updateUseCaseOntologyFilterRequest({ id: use_case_id, onto_manage_id: onto_manage_id }));
                    }}
                    hideLine={true}
                    ontoManageId={Number(selectedOntology)}
                  />
                </Box>
                <Box
                    sx={{
                        ...Styles.masterPaperContainer,
                        border: `1px solid #D9DFED`,
                        backgroundColor: '#fff',
                        overflow: 'hidden',
                        height: 'calc(100vh - 260px)',
                    }}
                >
                    <iframe
                        src={url}
                        title="Grafana Dashboard"
                        style={{ width: '100%', height: '100%', border: 'none' }}
                        allowFullScreen
                    />
                </Box>
              </Box>
            );
        }
    }
    // return <div>No Grafana dashboard ID provided.</div>;
    return (
      <Typography variant='h5' sx={{ mb: 2, mt: 3, textAlign: 'center', color: '#6b7a99', fontWeight: 500 }}>
        No Dashboard Found
      </Typography>
    );
};

const mapStateToProps = (state: any) => ({
  isOntoManagesLoading: state.ontologyMaster.isOntoManagesLoading,
  ontologyData: state.ontologyMaster.ontologyData,
  deployedUsecaseData: state.useCaseBuilder.deployedUsecaseData,
});

export default connect(mapStateToProps)(DashboardLoader);
